import { OrderBuilderActions, RESET_BUILDER } from '../../../modules/order-builder/actions/order-builder.actions';
import { Actions, ActionTypes } from '@ordersnproducts/modules/shared/actions/order-subscription.actions';

export interface State {
  componentEnabled: boolean;
  emails: string[];
  phones: string[];
  emailSubscribed: boolean;
  phoneSubscribed: boolean;
  patching: boolean;
  triggerCheck: boolean;
  canDeleteFirstElement: boolean;
  phoneCode: string;
  showDiscardModal: boolean;
}

const initialState: State = {
  componentEnabled: false,
  emails: [],
  phones: [],
  emailSubscribed: false,
  phoneSubscribed: false,
  patching: false,
  triggerCheck: false,
  canDeleteFirstElement: false,
  phoneCode: '1',
  showDiscardModal: false,
};

export function reducer(state = initialState, action: Actions | OrderBuilderActions): State {
  switch (action.type) {
    case ActionTypes.LOAD_COMPONENT:
    case ActionTypes.LOAD_ORDER_DETAIL_COMPONENT:
    case ActionTypes.LOAD_ORDER_SUMMARY_COMPONENT:
    case ActionTypes.LOAD_FAILURE: {
      return state;
    }
    case ActionTypes.ENABLE_COMPONENT_MOO:
    case ActionTypes.ENABLE_COMPONENT: {
      return { ...state, componentEnabled: true };
    }
    case ActionTypes.DISABLE_COMPONENT: {
      return { ...state, componentEnabled: false };
    }
    case ActionTypes.FETCH_DESTINATIONS: {
      return state;
    }
    case ActionTypes.FETCH_DESTINATIONS_MOO_SUCCESS:
    case ActionTypes.FETCH_DESTINATIONS_SUCCESS: {
      return {
        ...state,
        emails: action.payload.emails,
        phones: action.payload.phones,
        emailSubscribed: action.payload.emailSubscribed,
        phoneSubscribed: action.payload.phoneSubscribed,
        canDeleteFirstElement: action.payload.canDeleteFirstElement,
        phoneCode: action.payload.phoneCode,
      };
    }
    case ActionTypes.FETCH_DESTINATIONS_FAILURE: {
      return state;
    }
    case ActionTypes.PATCH_DESTINATIONS: {
      return { ...state, patching: true };
    }
    case ActionTypes.PATCH_DESTINATIONS_MOO_SUCCESS:
    case ActionTypes.PATCH_DESTINATIONS_SUCCESS: {
      return {
        ...state,
        patching: false,
        emailSubscribed: action.payload.emailSubscribed,
        phoneSubscribed: action.payload.phoneSubscribed,
        emails: action.payload.emails,
        phones: action.payload.phones,
      };
    }
    case ActionTypes.PATCH_DESTINATIONS_FAILURE: {
      return { ...state, patching: false };
    }
    case ActionTypes.TRIGGER_SUBSCRIPTION_CHECK: {
      return { ...state, triggerCheck: action.payload };
    }
    case ActionTypes.SHOW_DISCARD_MODAL: {
      return { ...state, showDiscardModal: action.payload.showDiscardModal };
    }
    case RESET_BUILDER:
    case ActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
